import React from "react";
import logger from "../../utils/logger";

/**
 * A mascot failure must never take the storefront down. Anything thrown while
 * rendering (or while its sprite manifest loads) is swallowed here and the page
 * renders exactly as it would without the character.
 */
export default class MascotBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    logger.warn?.("22night mascot crashed and was disabled", error, info);
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}
